module.exports = __webpack_public_path__ + "img/data_null.4cd689f2.png";